import createApi from './api';

export default class ProcessTagsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/tags',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadAll({ process_id, from_ts, to_ts, container_level, include_employees }) {
    return this.api.get('get', {
      process_id,
      from_ts,
      to_ts,
      include_employees,
      container_level,
    })
  }

  async create(tag) {
    return this.api.post('add', tag);
  }

  async update(tag) {
    return this.api.post('update', tag);
  }

  async remove({ id }) {
    return this.api.post('remove', { id });
  }
}
